(function () {
  if (!document.body) return;

  function cartAddUrl() {
    var url = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
    if (url.indexOf('.js') === -1) url += '.js';
    return url;
  }

  function firstAvailableVariantId(product) {
    if (!product || !product.variants || !product.variants.length) return '';
    var available = product.variants.filter(function (v) { return v.available; });
    var variant = available.length ? available[0] : product.variants[0];
    return variant && variant.id ? String(variant.id) : '';
  }

  function resolveVariantId(btn) {
    var handle = btn.getAttribute('data-product-handle') || '';
    var fallbackId = btn.getAttribute('data-variant-id') || '';
    if (!handle) return Promise.resolve(fallbackId);

    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (product) {
        return firstAvailableVariantId(product) || fallbackId;
      })
      .catch(function () {
        return fallbackId;
      });
  }

  function collectSectionIds() {
    var cartDrawer = document.querySelector('cart-drawer');
    var pageCartItems = document.querySelector('cart-items');
    var sectionIds = [];

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      cartDrawer.getSectionsToRender().forEach(function (section) {
        if (section.id && sectionIds.indexOf(section.id) === -1) sectionIds.push(section.id);
      });
    }
    if (pageCartItems && typeof pageCartItems.getSectionsToRender === 'function') {
      try {
        pageCartItems.getSectionsToRender().forEach(function (section) {
          var id = section.section || section.id;
          if (id && sectionIds.indexOf(id) === -1) sectionIds.push(id);
        });
      } catch (e) {}
    }
    if (sectionIds.indexOf('cart-icon-bubble') === -1) sectionIds.push('cart-icon-bubble');
    return sectionIds;
  }

  function refreshCart(cartData) {
    var cartDrawer = document.querySelector('cart-drawer');
    var pageCartItems = document.querySelector('cart-items');

    if (cartDrawer) {
      if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
      var emptyEl = cartDrawer.querySelector('.drawer__inner-empty');
      if (emptyEl) emptyEl.remove();

      if (cartData.sections && typeof cartDrawer.renderContents === 'function') {
        try {
          cartDrawer.renderContents(cartData);
        } catch (e) {
          console.error('Jewellery PLP cart drawer update failed:', e);
        }
      }
      if (typeof cartDrawer.open === 'function') cartDrawer.open();
    }

    if (pageCartItems && typeof pageCartItems.onCartUpdate === 'function') {
      pageCartItems.onCartUpdate();
    }

    if (typeof updateCartIconBubble === 'function') updateCartIconBubble();
    if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'jewellery-plp-atc', cartData: cartData });
    }
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  function setLoading(btn, isLoading) {
    var label = btn.querySelector('.plp-jewellery-atc-btn__label');
    btn.classList.toggle('is-loading', isLoading);
    btn.disabled = isLoading || btn.classList.contains('is-added');
    btn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    if (isLoading && label) label.textContent = 'Adding...';
  }

  function markAdded(btn) {
    var label = btn.querySelector('.plp-jewellery-atc-btn__label');
    btn.classList.remove('is-loading');
    btn.classList.add('is-added');
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'false');
    if (label) label.textContent = 'Added';
  }

  function resetButton(btn) {
    var label = btn.querySelector('.plp-jewellery-atc-btn__label');
    btn.classList.remove('is-loading', 'is-added');
    btn.disabled = false;
    btn.setAttribute('aria-busy', 'false');
    if (label) label.textContent = 'Add to cart';
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-jewellery-atc]');
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    if (btn.disabled || btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;

    setLoading(btn, true);

    resolveVariantId(btn)
      .then(function (variantId) {
        if (!variantId) throw new Error('Could not add product to cart.');

        var payload = {
          items: [{ id: Number(variantId), quantity: 1 }]
        };
        var sectionIds = collectSectionIds();
        if (sectionIds.length) {
          payload.sections = sectionIds;
          payload.sections_url = window.location.pathname;
        }

        return fetch(cartAddUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
          body: JSON.stringify(payload)
        }).then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok || data.status) {
              throw new Error(data.description || data.message || 'Could not add product to cart.');
            }
            return data;
          });
        });
      })
      .then(function (cartData) {
        markAdded(btn);
        refreshCart(cartData);
      })
      .catch(function (err) {
        console.error('Jewellery PLP add to cart error:', err);
        resetButton(btn);
        var errEl = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errEl) errEl.textContent = (err && err.message) ? err.message : 'Could not add product to cart.';
      });
  }, true);
})();
